import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import Local from '../../../../components/Local/Local';
import GameCardsWidget from '../GameCardsWidget';
import { useRecentGames } from '../../../../hooks/useRecentGames';
import { getDataTestAttrs } from '../../../../utils/testing-locators';
import { getGames, getGamesWithLimit } from '../utils';
import { RECENT_GAMES_LIST } from '../../../../constants/dataTestIds';
import { useIsDesktopLayout } from '../../../../hooks/useIsDesktopLayout';
import { getRecentGamesRoute } from '../../../../utils/routes';

import { ANALYTICS_SCREEN_AREA_DETAILS } from '../../../../constants/analytics';
import styles from './GameCardsWidgetRecentLaunched.module.css';
import WidgetLoaded from '../../RenderPixelProvider/WidgetLoaded';

export const MAX_RECENT_GAMES_CARDS_MOBILE = 2;
export const MAX_RECENT_GAMES_CARDS_DESKTOP = 8;

const GameCardsWidgetRecentLaunched = ({
  excludeGameIds,
  className,
  analyticsData,
  ...props
}) => {
  const { isLoading, data } = useRecentGames();
  const isMobile = !useIsDesktopLayout();
  const recentGames = getGames(isLoading ? [] : data, excludeGameIds);
  const limit = isMobile
    ? MAX_RECENT_GAMES_CARDS_MOBILE
    : MAX_RECENT_GAMES_CARDS_DESKTOP;
  const items = getGamesWithLimit(recentGames, limit);

  return !isEmpty(items) ? (
    <>
      <GameCardsWidget
        items={items}
        limit={limit}
        title={
          <>
            <Local>Recent games</Local>
            <span className={styles.count}>
              <Local values={{ count: recentGames?.length }}>
                {'({{ count }} games)'}
              </Local>
            </span>
          </>
        }
        analyticsData={{
          ...analyticsData,
          screen_area_detail: ANALYTICS_SCREEN_AREA_DETAILS.RECENT_GAME,
        }}
        link={getRecentGamesRoute()}
        className={className}
        {...getDataTestAttrs(RECENT_GAMES_LIST)}
        {...props}
      />
      <WidgetLoaded />
    </>
  ) : (
    <WidgetLoaded />
  );
};

GameCardsWidgetRecentLaunched.propTypes = {
  excludeGameIds: PropTypes.array,
  analyticsData: PropTypes.shape({
    screen_name: PropTypes.string,
    screen_area: PropTypes.string,
  }),
};

GameCardsWidgetRecentLaunched.defaultProps = {
  excludeGameIds: [],
  analyticsData: {},
};

export default GameCardsWidgetRecentLaunched;
